// @ts-nocheck — звичайний JavaScript для браузера, без типів TypeScript
/* Стікери для редактора рамок (вкладка «Стікери»).

   Як додати свій:
     1. Заливаєш файл у Shopify → Content → Files, копіюєш посилання.
     2. Вставляєш рядком у потрібну категорію нижче, у лапках, з комою.
     3. Усе. Стікер зʼявиться в редакторі сам.

   ─── ДОВІДКА ────────────────────────────────────────────────────
   Категорії — це ключі списку. Порожні клієнтам НЕ показуються,
   тож можна лишати їх про запас. Нову категорію просто дописуєш —
   вона зʼявиться в тому порядку, у якому стоїть у файлі.

   PNG і SVG лежать разом, в одному списку. Редактор сам бачить формат
   за розширенням і поводиться з ними по-різному:

   PNG — звичайна картинка:
     • тільки з прозорим тлом; JPG не годиться — буде білий квадрат;
     • довша сторона 600–1000 px, більше не потрібно;
     • порожні поля навколо малюнка обрізаються автоматично.

   SVG — лишається вектором:
     • не мутніє ні при збільшенні, ні у друці, важить копійки;
     • одноколірний можна перефарбувати в редакторі, багатоколірний — ні;
     • файл має лежати на нашому домені, інакше браузер його не прочитає.
   ──────────────────────────────────────────────────────────────── */
window.FE_STICKER_LIB = {

  'Серця': [
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_png_serce1.png?v=1787932603',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_png_serce2.png?v=1787932610',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_png_serce3.png?v=1787932615',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_png_sercapiksel.png?v=1787932650',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_svg_serce1.svg?v=1787945980',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_svg_serce2.svg?v=1787945983',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_svg_serce3.svg?v=1787945992',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_svg_serce4.svg?v=1787947642',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_svg_serce5.svg?v=1787947647',
  ],

  'Новий рік': [
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_png_ng1.png?v=1787932578',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_png_ng2.png?v=1787949028',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_png_ng3.png?v=1787949475',
  ],

  'День народження': [
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_png_kniga.png?v=1787932536',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_png_kolpak.png?v=1787932539',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_png_tort.png?v=1787932558',
  ],

  'Весілля': [
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_png_obruchka.png?v=1787932580',
  ],

  'Губи': [
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_png_gubi.png?v=1787932530',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_png_gubi2.png?v=1787949014',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_png_gubi3.png?v=1787949017',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_png_gubi4.png?v=1787949020',
  ],

  'Школа': [
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_svg_zirka.svg?v=1787946026',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_svg_zemlya.svg?v=1787946024',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_svg_rukzak.svg?v=1787946021',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_svg_pencil.svg?v=1787946018',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_svg_list.svg?v=1787946016',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_svg_kolba.svg?v=1787946008',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_svg_kapeluh.svg?v=1787946005',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_svg_farba.svg?v=1787946002',
  ],

  'Предмети': [
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_png_groshi.png?v=1787932526',
  ],

  'Різне': [
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_svg_pleer.svg?v=1787945973',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_png_doloni1.png?v=1787932455',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_png_doloni2.png?v=1787932514',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_png_family.png?v=1787932517',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_png_galka1.png?v=1787932520',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_png_galka2.png?v=1787932523',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_png_mishenia.png?v=1787932571',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_png_photo.png?v=1787932585',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_png_strichka.png?v=1787932589',
  ],

  'Стрілки': [
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_svg_no.svg?v=1787947658',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_svg_yes.svg?v=1787947667',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_svg_strilka1.svg?v=1787947686',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_svg_strilka2.svg?v=1787947688',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_svg_strilka3.svg?v=1787947691',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_svg_strilka4.svg?v=1787947694',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_svg_strilka5.svg?v=1787947705',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_svg_strilka6.svg?v=1787947707',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_svg_strilka7.svg?v=1787947709',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_svg_strilka8.svg?v=1787947712',
    'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/s_svg_strilka9.svg?v=1787947714',
  ],

};
